import { PdpContextKey } from './context'

export const usePdp = () => {
  const data = inject(PdpContextKey)!

  if (!data) console.warn('usePdp() should be used inside a PDP page')

  return data
}
